var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-1"},[_c('b-modal',{ref:"publish-modal",attrs:{"size":"mg","id":"modal-center","centered":"","hide-footer":""}},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('img',{staticStyle:{"width":"80%"},attrs:{"src":require("../assets/banklist.jpg")}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }